import React from 'react';
import OverlappingValuePropsItem from './OverlappingValuePropsItem';
import PropTypes from 'prop-types';
import cnames from 'classnames';
import { connect } from 'react-redux';

import './OverlappingValueProps.less';

const CNAME = 'OverlappingValueProps';

const OverlappingValueProps = ({
  valuePropHeading1,
  valuePropHeading2,
  valuePropHeading3,
  valuePropSubheading1,
  valuePropSubheading2,
  valuePropSubheading3
}) => (
  <div className={cnames(CNAME, 'hidden-xs')}>
    <ul className={`${CNAME}__list`}>
      <OverlappingValuePropsItem title={valuePropHeading1} blurb={valuePropSubheading1}/>
      <OverlappingValuePropsItem title={valuePropHeading2} blurb={valuePropSubheading2}/>
      <OverlappingValuePropsItem title={valuePropHeading3} blurb={valuePropSubheading3}/>
    </ul>
  </div>
);

OverlappingValueProps.propTypes = {
  valuePropHeading1: PropTypes.string,
  valuePropHeading2: PropTypes.string,
  valuePropHeading3: PropTypes.string,
  valuePropSubheading1: PropTypes.string,
  valuePropSubheading2: PropTypes.string,
  valuePropSubheading3: PropTypes.string
};

OverlappingValueProps.defaultProps = {
  valuePropHeading1: '',
  valuePropHeading2: '',
  valuePropHeading3: '',
  valuePropSubheading1: '',
  valuePropSubheading2: '',
  valuePropSubheading3: ''
};

const mapStateToProps = ({
  content: { siteStaticContent }
}) => ({
  valuePropHeading1: siteStaticContent.overlappingValueProp1Heading,
  valuePropHeading2: siteStaticContent.overlappingValueProp2Heading,
  valuePropHeading3: siteStaticContent.overlappingValueProp3Heading,
  valuePropSubheading1: siteStaticContent.overlappingValueProp1Subheading,
  valuePropSubheading2: siteStaticContent.overlappingValueProp2Subheading,
  valuePropSubheading3: siteStaticContent.overlappingValueProp3Subheading
});

export default connect(mapStateToProps, null)(OverlappingValueProps);
